export const CLUSTER_LIST_FIELDS = ['label', 'productClustersCount', 'shopClustersCount', 'color'];
export const SHOPS_CLUSTER_LIST_FIELDS = ['shop_id', 'retailer', 'name', 'address', 'city', 'postcode', 'cluster'];
export const PRODUCT_CLUSTER_LIST_FIELDS = ['ean', 'name', 'cluster'];
